<template>
    <div class="sss-yc-mx">
        <div class="tit">预测明细</div>
        
        <el-form inline class="filter-form">
            <el-form-item>
                <el-input v-model="form.number" placeholder="请输入期数" 
				clearable 
				></el-input>
            </el-form-item>
            <el-form-item>
                <el-select v-model="form.preType" placeholder="请选择彩种" clearable>
                    <el-option v-for="(item,index) in lotteryType" :key="index" :label="item.dictLabel"
                               :value="item.dictValue"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-date-picker
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="getList">搜索</el-button>
            </el-form-item>
        </el-form>
        
        <!-- 移动端：表格横向可滑动查看，避免列被压扁 -->
        <div class="table-scroll">
        <el-table
            v-loading="tableLoading"
            :data="list"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
        
        >
            <!-- <el-table-column type="index" label="序号"></el-table-column> -->
            <el-table-column prop="preTypeName" label="彩种">
            </el-table-column>
            <el-table-column prop="number" label="期数"></el-table-column>
            <el-table-column prop="createTime" label="预测时间" width="300"></el-table-column>
            <el-table-column prop="preIndexTypeName" label="预测指标类型">
            </el-table-column>
            <!-- <el-table-column prop="isForcasted" label="对与错"></el-table-column> -->
            <el-table-column prop="score" label="得分"></el-table-column>
            <!-- <el-table-column prop="" label="操作"></el-table-column> -->
        </el-table>
        </div>
        
        <el-pagination v-if="listPagin.total > 9"
                       class="pager"
                       background
                       layout="prev, pager, next"
                       @current-change="changePage"
                       :page-size="listPagin.limit"
                       :total="listPagin.total">
        </el-pagination>
    </div>
</template>

<script>
import {yucemingxi_detailList} from "@/api/personalCenter"
import {queryLotteryType} from "@/api/common";

export default {
    data() {
        return {
            time: [],
            list: [],
            
            lotteryType: [],
            
            form: {
                number: '',
                preType: '',
            },
            
            tableLoading: true,
            listPagin: {
                page: 1,
                limit: 10,
                total: 0
            },
        }
    },
    mounted() {
        this.getList()
        
        queryLotteryType().then(res => {
            this.lotteryType = JSON.parse(JSON.stringify(res.data, ['dictLabel', 'dictValue']))
        })
    },
    methods: {
        getList() {
			let time = this.time

            yucemingxi_detailList({
                pageNum: this.listPagin.page,
                pageSize: this.listPagin.limit,
                startDate: time ? time[0] :'',
                endDate: time ? time[1] :'',
                number: this.form.number,
                preType: this.form.preType,
            }).then(res => {
                this.tableLoading = false
                this.list = res.rows
                
                this.listPagin.total = res.total
            })
        },
        // 分页状态变化
        changePage(e) {
            this.tableLoading = true
            this.listPagin.page = e
            this.getList();
        },
    }
}
</script>

<style lang="scss" scoped>
.sss-yc-mx {
    .tit {
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .shaixuan {
        background-color: #dbdbdb;
        padding: 10px;
        display: flex;

        span {
            margin: 0 20px;
        }

        input {
            background-color: #ffffff;
        }

    }

    .grid {
        margin-top: 20px;
        text-align: center;

        > div {
            display: grid;
            grid-template-columns: repeat(7, 1fr);

            span {
                border: 1px solid rgba(0, 0, 0, 0.1);
                display: inline-block;
                padding: 10px 0;
            }
        }
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效，与项目全局断点保持一致） ===== */
@media (max-width: 1200px) {
    .sss-yc-mx {
        .tit {
            font-size: 20px;
            margin-bottom: 12px;
        }

        /* 筛选表单：每项独占一行，输入框铺满 */
        .filter-form {
            display: block;

            ::v-deep .el-form-item {
                display: block;
                margin-right: 0;
                margin-bottom: 10px;
            }

            ::v-deep .el-input,
            ::v-deep .el-select,
            ::v-deep .el-date-editor {
                width: 100% !important;
            }

            ::v-deep .el-date-editor--daterange {
                width: 100% !important;
            }

            ::v-deep .el-date-editor .el-range-input {
                font-size: 14px;
            }
        }

        /* 表格：横向可滑动，列宽保持不变不被压扁 */
        .table-scroll {
            width: 100%;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;

            ::v-deep .el-table {
                min-width: 560px;
            }

            ::v-deep .el-table th,
            ::v-deep .el-table td {
                padding: 8px 0;
                font-size: 13px;
            }
        }

        /* 分页：居中显示，按钮加大便于点击 */
        .pager {
            padding-top: 16px;
            text-align: center;

            ::v-deep .el-pagination {
                padding: 0;
                text-align: center;
                white-space: nowrap;
                overflow-x: auto;
            }

            ::v-deep .el-pager li,
            ::v-deep .btn-prev,
            ::v-deep .btn-next {
                min-width: 30px;
                margin: 0 2px;
            }
        }
    }
}
</style>